<template>
  <div>
    <div class="d-flex justify-content-center flex-wrap p-2">
      <div class="mb-2">
        <b-media class="d-block col-12">
          <template #aside>
            <div class="container-avatar-table">
              <b-avatar
                size="230px"
                :src="getImageInfluencer(influencer)"
                variant="light-primary"
                class="p-05"
              />
              <div class="container-avatar-table-icon">
                <b-avatar size="40" variant="light">
                  <b-img :src="getIconWhite(influencer.network)" :class="`${getIconColor(influencer.network, true)}`" fluid></b-img>
                </b-avatar>
              </div>
            </div>
          </template>
        </b-media>
      </div>
      <div class="d-flex flex-wrap text-no-wrap justify-content-center">
        <h3 class="text-center">
          {{ influencer.name }}
          <image-verified v-if="influencer.is_verified" class="square-20" />
        </h3>

        <h5 class="col-12 text-blue font-weight-bolder mb-1 text-center">
          @{{ getUsername(influencer) }}
        </h5>

        <b-badge :variant="statusInfluencerVariant(campaign_influencer.status_influencer)" :class="statusInfluencerVariant(campaign_influencer.status_influencer)" class="mb-2">
          {{ $t(getStatusInfluencer(campaign_influencer.status_influencer)) }}
        </b-badge>

        <!-- Followers y ER -->
        <div class="d-flex justify-content-between w-100 mb-2">
          <div class="text-center">
            <span class="text-muted d-block">{{$t('lists.followers')}}</span>
            <span>{{ getFormat(influencer.followers) }}</span>
          </div>
          <div class="text-center">
            <span class="text-muted d-block">{{ $t('campaigns.erTitle') }}</span>
            <span>{{ decimalFixed(influencer.engagement_rate) }} %</span>
          </div>
        </div>
      </div>

      <!-- External Campaign ID -->
      <div v-if="owner.valid && campaign.code_campaign && (owner.role === 'brand' || campaign.campaign_influencer.status_influencer === 'approved')" class="w-100 mb-2 text-center">
        <span class="text-muted d-block font-small-3">Código de campaña</span>
        <div class="d-flex align-items-center justify-content-center">
          <span class="font-weight-bold">{{ campaign.code_campaign }}</span>
          <feather-icon
            v-if="owner.role === 'creator'"
            :icon="copied ? 'CheckIcon' : 'CopyIcon'"
            size="15"
            class="ml-50 cursor-pointer"
            :class="copied ? 'text-success' : 'text-blue'"
            @click="copyExternalId()"
          />
        </div>
      </div>

      <!-- Container for edit budget -->
      <div class="mb-2 w-100">
        <span class="text-muted d-block text-center">{{$t('invitation.payColaboration')}}</span>
        <div class="d-flex align-items-center justify-content-center w-100 text-center">
          <span 
            class="d-flex align-items-center" 
            v-if="!is_editing_budget && owner.valid"
          >
            $ {{ separatebycomma(campaign_influencer.price_collab) }} USD
            <feather-icon 
              icon="EditIcon" 
              v-if="owner.role === 'brand' && owner.valid" 
              class="d-block ml-1 text-blue cursor-pointer" 
              size="18" 
              @click="is_editing_budget = true"
            ></feather-icon>
          </span>
          <div v-else-if="!user_data" class="d-flex align-items-center">
            <div class="lock-icon"><feather-icon icon="LockIcon" size="13" class="icon"/></div>
            <span>
              {{ $t('invitation.loginToKnow') }}
            </span>
          </div>
          <b-input-group v-else-if="owner.role === 'brand' && owner.valid" prepend="$">
            <b-form-input v-model="budget_editable" type="number" @keyup.enter="saveNewBudget()"></b-form-input>
            <b-input-group-append>
              <b-button variant="blue-button" class="blue-button" @click="saveNewBudget()">Guardar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

     <!-- Actions to approve or send whatsapp -->
      <div class="w-100">
        <h5 class="mb-1 text-center" v-if="campaign_influencer.status_influencer === 'pending'">{{ $t('campaigns.questionApproveProposal') }}</h5>
        <div class="d-flex justify-content-center flex-wrap w-100">
          <b-button
            class="blue-button w-100 mb-1"
            variant="blue-button"
            @click="verifyTYC()"
            v-if="campaign_influencer.status_influencer !== 'approved' && campaign_influencer.status_influencer !== 'rejected' && owner.role === 'creator' && owner.valid"
          >
            {{ $t('campaigns.acceptParticipate') }}
          </b-button>
          
          <b-button
            v-if="campaign.whatsapp_manager"
            class="w-100"
            variant="success"
            @click="redirectWhatsApp()"
          >
            {{ $t('campaigns.teamBM') }}
          </b-button>
        </div>
      </div>

      <!-- Component of register or login -->
      <login-register v-if="!user_data" class="border-top"></login-register>
    </div>
    <div class="px-2" v-if="owner.role === 'creator' && owner.valid">
      <!-- pretitle -->
       <div class="border-top pt-2" v-if="(campaign.campaign_influencer.status_link === 'pending_info_payment' || campaign.campaign_influencer.status_link === 'pending_tax_files')">
        <h3 class="text-center">{{ $t('invitation.weWantPayYou') }}</h3>
        <p class="avenir-medium text-justify">{{  $t(`invitation.${campaign.campaign_influencer.status_link === 'pending_info_payment' ? 'helpUsGiveUs' : 'loadYourTax'}`)  }}</p>
      </div>

      <!-- Payment form -->
      <div class="border-top" v-if="campaign.campaign_influencer.status_link === 'pending_info_payment'">
        <paymentData 
          :campaign="campaign" 
          @savePaymentData="savePaymentData" 
          @update_campaign_status="updateCampaignStatus"/>
      </div>

      <!-- Upload taxes files -->
       <div class="border-top pt-2" v-if="campaign.campaign_influencer.status_link === 'pending_tax_files'">
         <upload-receives :is_invitation_link="true" :is_ready_to_pay_invitation="is_ready_to_pay" @update_campaign_status="campaign.campaign_influencer.status_link = 'complete'"></upload-receives>
       </div>
    </div>
    
    <b-modal v-model="open_modal_sign" size="xl" centered hide-footer>
      <iframe
        v-if="campaign_influencer.contract_link && !campaign_influencer.signed_contract" 
        :src="campaign_influencer.contract_link"
        class="iframe-sign-pandadoc"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </b-modal>

    <div class="mt-auto border-top-lg pt-1 pl-1 pb-1" v-if="campaign_influencer.status_influencer === 'pending' && owner.role === 'creator' && owner.valid">
      <b-link class="decline-campaign" @click="changeStatus('rejected')">{{$t('campaigns.rejectBtn')}}</b-link>
    </div>

    <modal-brandme :show_modal="modal_accept_tyc" :key="modal_change_accept_tyc" :no_footer="true" ref="modal_accept_tyc">
      <template #title><h4 class="m-0">{{$t('ia.image.termsOfService')}}</h4></template>
      <template #body>
        <accpet-terms :campaign="campaign" @close_modal_tyc="$refs.modal_accept_tyc.show = false" @accept_terms="verifyTYC"/>
      </template>
    </modal-brandme>
  </div>
</template>

<script>
import { 
  BImg,
  BButton, 
  BLink,
  BMedia,
  BAvatar,
  BBadge,
  BFormInput,
  BModal,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import invitation_service from "@/services/invitation";
import campaign_service from "@/services/campaign";
import { getIconWhite, getIconColor } from '@/libs/utils/icons'
import { getImageInfluencer, showToast } from '@/libs/utils/others';
import { statusVariant } from '@/libs/utils/series_graphs';
import { getFormat, separatebycomma, decimalFixed } from '@/libs/utils/formats';
import { getUserData } from '@/libs/utils/user';

export default {
  name: 'acceptDecline',
  components: {
    BImg,
    BButton,
    BLink,
    BMedia,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BAvatar,
    BBadge,
    BModal,
    ImageVerified: () => import('@/views/components/image/ImageVerified.vue'),
    ModalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
    accpetTerms: () => import('@/views/components/invitation/accpetTerms.vue'),
    loginRegister: () => import('@/views/components/invitation/loginRegister.vue'),
    paymentData: () => import('@/views/components/invitation/paymentData.vue'),
    uploadReceives: () => import('@/views/forms/uploadReceives.vue')
  },
  props: {
    campaign: {
      required: true,
      type: Object,
    },
    owner: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      decimalFixed,
      separatebycomma,
      getFormat,
      getUserData,
      statusVariant,
      getImageInfluencer,
      getIconWhite,
      getIconColor,
      influencer: this.campaign.campaign_influencer.influencer,
      campaign_influencer: this.campaign.campaign_influencer,
      open_modal_sign: false,
      modal_change_accept_tyc: false,
      modal_accept_tyc: false,
      is_editing_budget: false,
      budget_editable: '',
      is_ready_to_pay: false,
      copied: false,
    }
  },
  computed: {
    user_data() {
      return this.getUserData();
    },
  },
  created() {
    if (this.campaign.campaign_influencer.status_link === 'pending_tax_files' && this.owner.valid) this.isReadyToPay();

    this.$store.watch(
      (state) => state.main_store.ready_to_pay_link_invitation,
      (val) => {
        this.is_ready_to_pay = val;
      }
    );
  },
  methods: {
    copyExternalId() {
      navigator.clipboard.writeText(this.campaign.code_campaign).then(() => {
        this.copied = true;
        setTimeout(() => { this.copied = false }, 2000);
      });
    },
    statusInfluencerVariant (status) {
      const types = {
        'approved': 'blue-button',
        'pending': 'light-success',
        'rejected': 'light-danger',
      }
      if (types[status]) return types[status]
      return ''
    },
    updateCampaignStatus() {
      this.campaign.campaign_influencer.status_link = 'pending_tax_files';
      this.isReadyToPay();
    },
    isReadyToPay() {
      invitation_service.readyToPay(this.campaign.campaign_influencer.uuid)
        .then(response => {
          if (response.status >= 400) {
            showToast(this, 'danger', 'AlertTriangleIcon', 'Error Status', '', {translate_title: false});
            return;
          }
          this.is_ready_to_pay = response.ready;
        })
        .catch(() => {
          showToast(this, 'danger', 'AlertTriangleIcon', 'Error Status', '', {translate_title: false});
        });
    },
    saveNewBudget() {
      const data = {
        price_collab: this.budget_editable,
        campaign_influencer_uuid: this.campaign.campaign_influencer.uuid,
      };
      campaign_service.changePriceCollab(this.campaign.slug_name, data)
        .then(response => {
          if (response.status >= 400) {
            showToast(this, 'danger', 'AlertTriangleIcon', 'campaigns.error_update_budget_text',);
            return;
          } 
          this.is_editing_budget = false;
          this.campaign.campaign_influencer.price_collab = response.campaign_influencer.price_collab;
          showToast(this, 'success', 'CoffeeIcon', 'campaigns.success_update_budget_title', 'campaigns.success_update_budget_text');
        })
    },
    getStatusInfluencer (status) {
      const types = {
        'approved': 'campaigns.approvedInfluencer',
        'pending': 'campaigns.pendingInfluencer',
        'rejected': 'campaigns.rejectedInfluencer',
      }
      if (types[status]) return types[status]
      return ''
    },
    redirectWhatsApp() {
      const url = `https://wa.me/${this.campaign.code_whatsapp_manager}${this.campaign.whatsapp_manager}`
      window.open(url, '_blank');
    },
    getUsername(influencer) {
      if (influencer.network === "youtube") return influencer.name;
      return influencer.username;
    },
    publishedContents() {
      let counter = 0;
      this.campaign.campaign_influencer.content.map((content) => {
        if (content.image_content !== null || content.url_info !== null) counter += 1;
      })
      return counter;
    },
    verifyTYC() {
      if (this.campaign.campaign_influencer.accept_tyc) {
        this.changeStatus('approved');
      } else {
        this.modal_accept_tyc = true;
        this.modal_change_accept_tyc = !this.modal_change_accept_tyc;
      }
    },
    savePaymentData() {
      this.influencer.has_payment_data = true
    },
    changeStatus(status) {
      invitation_service.changeInfluencerStatus(this.campaign.campaign_influencer.uuid, status)
        .then(response => {
          const title = status === 'approved' ? this.$t('campaigns.proposalAccepted') : this.$t('campaigns.proposalRejected')
          const variant = status === 'approved' ? 'success' : 'danger'
          showToast(this, variant, 'CoffeeIcon', title);

          this.campaign.campaign_influencer.status_influencer = response.campaign_influencer.status_influencer;
          this.campaign.campaign_influencer.status_link = response.campaign_influencer.status_link;
        })
    }
  },
  watch: {
    is_editing_budget(val) {
      if (val) {
        this.budget_editable = this.campaign.campaign_influencer.price_collab;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .lock-icon {
    background-color: #EFEFEF;
    border-radius: 100%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 0.5em;
    .icon {
      color: black !important;
    }
  }
  .square-20 {
    width: 20px;
    height: 20px;
  }
  .p-05 {
    padding: 0.5em;
  }
  .text-no-break{
    justify-content: center !important;
    word-wrap: normal !important
  }
  .end-div {
    margin-top: auto !important;
  }
  .decline-campaign, .decline-campaign:hover {
    color: #B04254;
  }
  .decline-campaign:hover {
    text-decoration: underline;
  }

  .border-top-lg {
    border-top: 1px solid #EFEFEF;
  }
  .container-avatar-table {
    position: relative;
  }
  .media-aside {
    justify-content: center !important;
  }
  .container-avatar-table-icon {
    position: absolute; 
    bottom: 1.3em; 
    right: 1em;
  }
  .container-avatar-table .b-avatar-img {
    padding: 0.5em !important;
    background-color: #f6f6f6;
    margin: 0 auto !important;
  }
</style>
<style lang="scss" scoped>
.iframe-sign-pandadoc {
  width: 100%;
  height: 90vh;
}
</style>